import { useTranslation } from "react-i18next";
import { resolveTeam, MOCK_TEAMS } from "./teams-mock";

// Splitter altinda acilan takim (destek grubu) bilgi karti: aciklama, lider,
// uye listesi ve acik ticket istatistigi.
export function TeamInfoPane({ teamRef }: { teamRef: string }) {
    const { t } = useTranslation();
    const team = resolveTeam(teamRef, MOCK_TEAMS);

    if (!team) {
        return (
            <div className="flex items-center justify-center h-full w-full" style={{ color: "var(--subtitle-text-color)" }}>
                {t("teamNotFound")}
            </div>
        );
    }

    const initials = team.name.split(" ").map(w => w[0]).join("").toUpperCase().slice(0, 2);

    return (
        <div className="h-full w-full" style={{ overflowY: "auto", padding: 16, color: "var(--base-text-color)" }}>
            {/* Baslik */}
            <div className="flex items-center gap-3" style={{ marginBottom: 16 }}>
                <div className="flex items-center justify-center shrink-0" style={{ width: 48, height: 48, borderRadius: 10, background: "var(--accent-color, #6366F1)", color: "#fff", fontWeight: 600, fontSize: 16 }}>
                    {initials}
                </div>
                <div className="min-w-0">
                    <div className="font-semibold truncate" style={{ fontSize: 16 }}>{team.name}</div>
                    <div className="text-xs truncate" style={{ color: "var(--subtitle-text-color)" }}>
                        {team.description}
                        {team.is_active === false && <span style={{ color: "#EF4444", marginLeft: 8 }}>• {t("passive")}</span>}
                    </div>
                </div>
            </div>

            {/* Istatistik */}
            <div className="grid grid-cols-2 gap-3" style={{ marginBottom: 16 }}>
                <Stat label={t("members")} value={team.members.length} color="#6366F1" />
                <Stat label={t("openTickets")} value={team.openTickets} color="#F97316" />
            </div>

            {/* Lider */}
            <Section title={t("teamLead")}>
                <MemberRow name={team.lead} role={t("teamLead")} last />
            </Section>

            {/* Uyeler */}
            <Section title={t("members")}>
                {team.members.map((m, i) => (
                    <MemberRow key={m.name + i} name={m.name} role={m.role} last={i === team.members.length - 1} />
                ))}
            </Section>
        </div>
    );
}

function Stat({ label, value, color }: { label: string; value: number; color: string }) {
    return (
        <div style={{ background: "var(--base-bg)", border: "1px solid var(--border-color)", borderRadius: 10, padding: "12px 14px" }}>
            <div style={{ fontSize: 22, fontWeight: 700, color }}>{value}</div>
            <div className="text-xs" style={{ color: "var(--subtitle-text-color)" }}>{label}</div>
        </div>
    );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
    return (
        <div style={{ marginBottom: 16 }}>
            <div className="text-xs font-semibold uppercase" style={{ letterSpacing: "0.04em", color: "var(--subtitle-text-color)", marginBottom: 6 }}>
                {title}
            </div>
            <div style={{ background: "var(--base-bg)", border: "1px solid var(--border-color)", borderRadius: 10, overflow: "hidden" }}>
                {children}
            </div>
        </div>
    );
}

function MemberRow({ name, role, last }: { name: string; role: string; last?: boolean }) {
    const initials = name.split(" ").map(w => w[0]).join("").toUpperCase().slice(0, 2);
    return (
        <div className="flex items-center gap-3" style={{ padding: "10px 14px", borderBottom: last ? "none" : "1px solid var(--border-color)" }}>
            <span className="flex items-center justify-center shrink-0" style={{ width: 30, height: 30, borderRadius: 8, background: "var(--base-bg-darken-4)", color: "var(--base-text-color)", fontSize: 11, fontWeight: 600 }}>
                {initials}
            </span>
            <div className="min-w-0">
                <div className="text-sm truncate">{name}</div>
                <div className="text-xs" style={{ color: "var(--subtitle-text-color)" }}>{role}</div>
            </div>
        </div>
    );
}
